import React, { lazy } from 'react';
import { getCrumb } from 'src/components/MainPage/_shared/Breadcrumbs/Breadcrumb';
import { roleSet } from 'src/constants/role';
import { nomenclatureCategoryLoader } from './NomenclatureCategoryPage/nomenclatureCategoryLoader';
import { supplierLoader } from './SupplierPage/supplierPageLoader';
import { warehouseLoader } from './WarehousePage/warehouseLoader';

const NomenclatureCategoriesPage = lazy(
  () => import('./NomenclatureCategoriesPage/')
);
const NomenclatureCategoryPage = lazy(
  () => import('./NomenclatureCategoryPage/')
);
const WarehousesPage = lazy(() => import('./WarehousesPage/'));
const WarehousePage = lazy(() => import('./WarehousePage/'));
const SuppliersPage = lazy(() => import('./SuppliersPage/'));
const SupplierPage = lazy(() => import('./SupplierPage/'));

export const directoriesTabs = [
  {
    path: 'nomenclature-categories',
    element: <NomenclatureCategoriesPage />,
    handle: {
      label: 'Категории номенклатур',
      crumb: getCrumb('Категории номенклатур', true),
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
    children: [
      {
        path: ':id',
        element: <NomenclatureCategoryPage />,
        loader: nomenclatureCategoryLoader,
      },
    ],
  },
  {
    path: 'warehouses',
    element: <WarehousesPage />,
    handle: {
      label: 'Склады',
      crumb: getCrumb('Склады', true),
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
    children: [
      {
        path: ':id',
        element: <WarehousePage />,
        loader: warehouseLoader,
      },
    ],
  },
  {
    path: 'suppliers',
    element: <SuppliersPage />,
    handle: {
      label: 'Поставщики',
      crumb: getCrumb('Поставщики', true),
      roles: roleSet.financeToSuperAdmin,
      nonFranchiseeAccessOnly: true,
    },
    children: [
      {
        path: ':id',
        element: <SupplierPage />,
        loader: supplierLoader,
      },
    ],
  },
];
